import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {Airport} from '../../interfaces/Airport';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class ArchivedAirportsService {

    private route = 'airport/archived';
    constructor(private http: AuthHttp) { }

    public getAirports(limit: number = 10, page = 1, name: string = ''): Promise<Pagination<Airport>> {
        return this.http
            .get(`${environment.baseUrl}${this.route}?limit=${limit}&page=${page}&name=${name}`)
            .map((res) => res.json()).toPromise();
    }

    public update(id: number) {
        return this.http.put(`${environment.baseUrl}${this.route}/${id}`, '').toPromise();
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airport/services/archived-airports/archived-airports.service.ts